import { HttpErrorKind, HttpErrorPage } from '@/pages/errors/HttpError'

/**
 * Shown when an authenticated viewer lacks a surface's permission atom — the
 * 403 kind of the HTTP error family (TO-640). Takes no props, so it cannot echo
 * the denied resource.
 */
export function ForbiddenPage() {
	return <HttpErrorPage kind={HttpErrorKind.Forbidden} />
}
